module.exports = __webpack_public_path__ + "img/18_20.779280d5.png";